export default function initialize() {
  return {
    acceptedSingingMachineCommunication: false,
    acceptedSingingMachineNewsletter: false,
    status: "Normal",  // MustAcceptCommunicationsError | NetworkError | Normal | Sending
  };
}
